/* ==========================================================================
   ZELICAT THEME - zc-choose-set.js
   "ZC — Choose Your Set" cards (snippets/zc-choose-set.liquid) on the standard product page.
   Offers come from the product (metafield custom.choose_set_offers, "Offer option" metaobjects).
   A card = one real variant (quantity 1). Choosing a card:
     1. selects that variant through the normal variant picker (assets/product.js does the rest:
        URL, hidden id field, gallery, server-rendered price / buttons),
     2. writes the card's quantity into the product form's quantity field.
   The amount shown on the card (and copied into the main price and the phone bar) is rendered by Liquid
   as variant.price x quantity, so it is exactly what is added to the cart. No price is computed here.
   Safe to load several times; survives the section re-render done after each variant change.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__zcChooseSet) return;
  window.__zcChooseSet = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const chosen = new WeakMap(); /* product section root -> chosen offer block id */

  const rootOf = (el) => el.closest('[data-product-section]');
  const qtyInput = (root, set) => {
    const id = set.dataset.formId;
    return $(`input[name="quantity"][form="${id}"]`) || $('[data-qty]', root);
  };

  function readOptions(card) {
    const el = $('[data-zc-set-options]', card);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function setQty(root, set, qty) {
    const input = qtyInput(root, set);
    if (!input) return;
    if (Number(input.max) && Number(input.max) < qty) input.max = qty;
    if (String(input.value) !== String(qty)) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* copy the selected card's amount into the main price and the phone bar, so every price on the page
     matches what Add to cart sends (the card amount already includes the quantity) */
  function mirrorPrice(root, set, card) {
    if (set.dataset.followPrice !== 'true') return;
    const price = $('[data-zc-set-price]', card);
    if (!price) return;
    const html = `<span class="price__current">${price.innerHTML}</span>`;
    const main = $('[data-zc-swap="price"]', root);
    if (main && main.innerHTML !== html) main.innerHTML = html;
    const bar = $('[data-zc-swap="zcs-bar-price"]', root);
    const barHtml = `<span>${price.innerHTML}</span>`;
    if (bar && bar.innerHTML !== barHtml) bar.innerHTML = barHtml;
  }

  function paint(set, card) {
    $$('[data-zc-set-offer]', set).forEach((c) => {
      const on = c === card;
      c.classList.toggle('is-selected', on);
      const r = $('input[type="radio"]', c);
      if (r) r.checked = on;
    });
  }

  /* select the variant of the card through the variant picker; returns true when it changed */
  function selectVariant(root, card) {
    const idInput = $('[data-variant-id]', root);
    if (idInput && String(idInput.value) === String(card.dataset.variant)) return false;
    const options = readOptions(card);
    const groups = $$('[data-option]', root);
    if (!options || !groups.length) return false;
    let last = null;
    options.forEach((val, i) => {
      const g = groups[i];
      if (!g) return;
      $$('input[type="radio"]', g).forEach((r) => {
        const on = r.value === val;
        if (on && !r.checked) last = r;
        r.checked = on;
      });
      const s = $('select', g);
      if (s && s.value !== val) { s.value = val; last = s; }
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    return !!last;
  }

  function choose(set, card, fromUser) {
    const root = rootOf(set);
    if (!root || !card) return;
    /* an unavailable card (combination missing or sold out) can never be picked by the customer */
    if (fromUser && card.classList.contains('is-unavailable')) return;
    chosen.set(root, card.dataset.zcSetOffer);
    paint(set, card);
    setQty(root, set, Number(card.dataset.qty) || 1);
    if (fromUser) selectVariant(root, card);
    mirrorPrice(root, set, card);
  }

  /* after a re-render (variant change): keep the offer the customer chose, else the one matching the variant */
  function restore(set) {
    const root = rootOf(set);
    if (!root) return;
    const cards = $$('[data-zc-set-offer]', set).filter((c) => c.dataset.variant);
    if (!cards.length) return;
    const idInput = $('[data-variant-id]', root);
    const current = idInput ? String(idInput.value) : '';
    const want = chosen.get(root);
    let card = want ? cards.find((c) => c.dataset.zcSetOffer === want && c.dataset.variant === current) : null;
    if (!card) card = cards.find((c) => c.dataset.variant === current && Number(c.dataset.qty) === 1)
      || cards.find((c) => c.dataset.variant === current)
      || $('.zc-set__card.is-selected', set);
    if (card) choose(set, card, false);
  }

  function init(set) {
    if (set.__zcSetReady) return;
    set.__zcSetReady = true;
    set.addEventListener('change', (e) => {
      const r = e.target.closest('.zc-set__radio');
      if (!r) return;
      e.stopPropagation(); /* not a variant-picker option: assets/product.js must ignore it */
      choose(set, r.closest('[data-zc-set-offer]'), true);
    });
    restore(set);
  }

  function scan(scope) { $$('[data-zc-set]', scope).forEach(init); }

  /* the block lives inside the product section; when assets/product.js swaps server-rendered parts
     (price, buttons...) after a variant change, re-apply the chosen offer */
  const mo = new MutationObserver((records) => {
    const roots = new Set();
    records.forEach((rec) => { const r = rec.target.nodeType === 1 && rootOf(rec.target); if (r) roots.add(r); });
    roots.forEach((root) => {
      const set = $('[data-zc-set]', root);
      if (!set) return;
      if (!set.__zcSetReady) { init(set); return; }
      const want = chosen.get(root);
      const card = want && $(`[data-zc-set-offer="${want}"]`, set);
      const idInput = $('[data-variant-id]', root);
      if (card && idInput && card.dataset.variant === String(idInput.value)) mirrorPrice(root, set, card);
    });
  });

  function start() {
    scan(document);
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
